// Constants for public files functionality

/** CSS class names for drag and drop target elements */
export const TARGET_CLASS_NAMES = {
  ASSET_CARD: 'js-asset-card',
  BOARD_CARD: 'js-board-card',
} as const

/** Status colors for board status indicators */
export const STATUS_COLORS = [
  'red',
  'blue',
  'green',
] as const

/** Default texts for empty state placeholder */
export const EMPTY_BOARD_TEXTS = {
  title: 'This board is empty',
  description: 'Upload content to this board to get started',
} as const

/** URL path segments for public links */
export const PUBLIC_LINK_PATHS = {
  BASE: '/links/fs',
  PARAM_PREFIX: 'fs',
} as const

/** Query parameters for file preview */
export const PREVIEW_QUERY_PARAMS = {
  FILE_ID: 'prv',
} as const

/** Item types for selection and context handling */
export const ITEM_TYPES = {
  BOARD: 'board',
  ASSET: 'asset',
  MIXED: 'mixed',
  NONE: 'none',
} as const

/** Context types for menu actions */
export const CONTEXT_TYPES = {
  BOARD: 'board',
  ASSET: 'asset',
} as const

export type ItemType = typeof ITEM_TYPES[keyof typeof ITEM_TYPES]
export type ContextItemType = typeof CONTEXT_TYPES[keyof typeof CONTEXT_TYPES] | null 